/**
 * English - `tipsBookings`: the ⓘ explanations on booking payments, service
 * payment options, session packages and refunds.
 */
const tipsBookings: Record<string, string> = {
  'payments.enabled':
    'On: customers pay online when they book, as each service is set up. Needs Razorpay connected under Payments. Off: bookings are free and prices are only shown.',
  'payments.default_mode':
    'What a service does unless it chooses its own. Full takes the whole price, Deposit a part of it, Pay at venue nothing online, and Customer chooses lets them pick.',
  'payments.deposit_type':
    'Fixed takes the same rupee amount on every booking. Percent takes a share of the service price. Example: 20% of ₹1,000 is ₹200.',
  'payments.deposit_value':
    'The deposit amount. A percent must be above 0 and up to 100; a fixed amount above ₹0. A deposit is never more than the price.',
  'payments.hold_minutes':
    'While the customer pays, nobody else can book the slot. If they do not pay in time, it frees up. From 5 to 30 minutes. Example: 15.',
  'payments.refund_cutoff_hours':
    'Cancelled at least this many hours before the appointment: a full refund. From 0 to 168 hours (one week). Example: 24.',
  'payments.late_cancel':
    'What a cancellation after that point gives back: everything, everything but the deposit, or nothing. Applies to customers cancelling online.',
  'payments.confirm_on_payment':
    'On: a booking is confirmed the moment it is paid, and the customer gets the confirmation. Off: it waits for you, as unpaid bookings do.',
  'refund.amount':
    'How much to give back, up to what was paid online and not refunded yet. The money returns to the customer’s card or UPI in 5-7 working days.',
  'refund.reason': 'Optional. A short note for your records, like "Clinic closed early". Up to 200 characters.',
  'service.payment_mode':
    'How this service takes money once online booking payments are on. Store default follows the setting in Bookings. A service with no price is always paid at the venue.',
  'service.deposit_type':
    'Store deposit uses the deposit set in Bookings. Or choose a fixed amount or a percent just for this service.',
  'service.deposit_value':
    'This service’s own deposit. A percent from above 0 up to 100, or rupees above ₹0. Example: ₹500 for a root canal.',
  'package.name': 'What customers see on the storefront, like "5 physiotherapy sessions". Up to 120 characters.',
  'package.description': 'Optional. A line or two about what is included or who it suits.',
  'package.services':
    'The services a credit can be used for. Booking any of them with a credit uses one session.',
  'package.sessions': 'How many sessions the package holds, from 1 to 500. Example: 5.',
  'package.price': 'What the customer pays once for all the sessions, in rupees. Example: ₹4,500 for 5 sessions.',
  'package.validity_days':
    'How long after buying the sessions can be used, from 1 to 3650 days. Leave empty to never expire. Example: 90.',
  'package.is_active':
    'Off takes the package off sale. Customers who already bought it can still use their sessions.',
  'purchase.sessions_used':
    'How many sessions the customer has used. Change it for a visit logged by hand. From 0 up to the total.',
  'purchase.refund_amount':
    'How much of the package price to give back, up to what was paid. Refunding does not cancel the package on its own.',
  'plan.package':
    'Optional. The card’s button sells this session package: the customer logs in, pays and gets the credits. Needs online booking payments.',
};

export default tipsBookings;
